const getData = () => {
  const { location } = window;
  const data = [{
    title: `流量限制功能发布`,
    id: 0,
    date: '2019-07-18',
    content: `
  新增流量限制功能，提供应用、接口级的多时间粒度流量控制，并提供紧急流量控制功能`,
    type: '1'
    },
    {
      title: `JAVA SDK 更新`,
      id: 1,
      date: '2019-05-10',
      content:`
  修复验签时间戳 Integer 类型强制转换报错问题，[使用说明](${location.origin}/#/documents)` ,
      type: '1'
    },
  ];
  return data;
}
export default getData